import { bodycamClient, rmsClient } from "./clients";
import { VideoData } from "../shared/interfaces/VideoData";

export interface ReportMetadataRecord {
  stationId: string;
  reportId: string;
  userId: string;
  rms: string;
  reportStatus: string;
  reportDescription?: string | null;
  reportModifiedById: string;
  reportSignedById?: string | null;
  signedAt?: string | null;
  rmsCommitById?: string | null;
  rmsCommitAt?: string | null;
  evidenceIds: string[];
  promptTokenUsage?: number;
  completionTokenUsage?: number;
  createdAt: string;
  updatedAt: string;
}

interface ReportMetadataResponse extends ReportMetadataRecord {
  canEdit: boolean;
}

export const getReportMetadata = async (
  reportId: string
): Promise<ReportMetadataResponse> => {
  const response = await rmsClient.get<ReportMetadataResponse>(
    "/report",
    {
      params: { reportId },
    }
  );

  return response.data;
};

export const getEvidenceData = async (
  evidenceId: string
): Promise<VideoData> => {
  const response = await bodycamClient.get<VideoData>(
    "/evidence/details",
    {
      params: { evidenceId },
    }
  );

  return response.data;
};

export const getIncidentData = async (
  reportId: string
) => {
  const response = await rmsClient.get(
    "/artifact",
    {
      params: { reportId },
    }
  );

  return response.data;
};
